import classNames from "classnames";
import { JorneyToHomeArea } from "views/j2h/JorneyToHomeReducer";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

export type JorneyGameOverProps = {
  win: boolean;
  players: String[];
};

type AreaButtonProps = {
  hidden: boolean;
  area: JorneyToHomeArea;
  selected: boolean;
  areaState: string[]; // 0: playerCount, 1: homePlayerCount ? / ?
  icon: string;
  here: boolean;
  gameOver: boolean;
  gameOverProps: JorneyGameOverProps | null;
  lineBreakPlayerCount: boolean;
};

type AreaAttributes = {
  backgroundColor: String;
};

function AreaButton({
  hidden,
  area,
  selected,
  areaState,
  icon,
  here,
  gameOver,
  gameOverProps,
  lineBreakPlayerCount,
}: AreaButtonProps) {
  const { t } = useTranslation();
  const [areaAttributes, setAreaAttributes] = useState<AreaAttributes>();
  useEffect(() => {
    const initArea = (area: JorneyToHomeArea) => {
      switch (area) {
        case JorneyToHomeArea.Square:
          setAreaAttributes({ backgroundColor: "" });
          return;
        case JorneyToHomeArea.Sky:
          setAreaAttributes({
            backgroundColor: "bg-sky-500",
          });
          return;
        case JorneyToHomeArea.Forest:
          setAreaAttributes({
            backgroundColor: "bg-green-700",
          });
          return;
        case JorneyToHomeArea.River:
          setAreaAttributes({
            backgroundColor: "bg-blue-700",
          });
          return;
        case JorneyToHomeArea.City:
          setAreaAttributes({
            backgroundColor: "bg-stone-500",
          });
          return;
      }
    };
    initArea(area);
  }, [area]);

  return (
    <div
      className={classNames("flex flex-col justify-center", { hidden: hidden })}
    >
      <div className="ml-auto mr-auto flex h-8">
        <div
          className={classNames("absolute transform -translate-x-1/2", {
            hidden: !gameOverProps?.win,
          })}
        >
          <i className="fas fa-trophy text-yellow-400" />
        </div>
        <div
          className={classNames("absolute transform -translate-x-1/2", {
            hidden: !here || gameOver,
          })}
        >
          <i className="fas fa-location-dot text-green-500" />
        </div>
      </div>
      <button
        className={classNames(
          `${
            selected || gameOverProps?.win || (!gameOver && here)
              ? "scale-[1.02]"
              : "scale-[0.95] opacity-[0.5]"
          } relative w-full h-full mt-1 py-1 rounded-lg font-medium !rounded-button transition-all duration-200 flex flex-col items-center justify-center text-base shadow-lg text-white bg-blue-600 destination-button ${
            areaAttributes?.backgroundColor
          }`
        )}
      >
        {/* Area name */}
        <div className="flex items-center justify-center">
          <i className={`fas ${icon} mr-2 fa-xs`} />
          {t("J2H." + JorneyToHomeArea[area])}
        </div>
        <div
          className={`flex gap-4${
            lineBreakPlayerCount ? "md:flex-row flex-col gap-0" : ""
          }`}
        >
          {/* current player count */}
          <div
            className={classNames("flex items-center justify-center text-sm", {
              hidden: gameOver,
            })}
          >
            <i className={`fas fa-users mr-1 fa-xs`} />
            {areaState[0]}
          </div>
          {/* home player count */}
          <div
            className={classNames("flex items-center justify-center text-sm", {
              hidden: gameOver,
            })}
          >
            <i className={`fas fa-house-user mr-1 fa-xs`} />
            {areaState[1]}
          </div>
        </div>
        {/* result board */}
        {gameOverProps && (
          <div className="my-3">
            {gameOverProps.players.map((player, index) => (
              <div key={index} className={classNames()}>
                {player}
              </div>
            ))}
          </div>
        )}
      </button>
    </div>
  );
}

AreaButton.defaultProps = {};

export default AreaButton;
